import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// SETTINGS APIS
// ================================

// 🔹 SAVE ADMIN SETTINGS
export async function saveAdminSettings(admin_set_data1, admin_set_data2, admin_set_cre_by) {
  try {
    const fd = new FormData();
    fd.append("admin_set_data1", admin_set_data1);
    fd.append("admin_set_data2", admin_set_data2);
    fd.append("admin_set_cre_by", admin_set_cre_by);

    const response = await axios.post(`${apiBaseUrl}settingsapis/save_admin_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveAdminSettings error:", error);
    return { status: false, type: "danger", success: "Admin settings save failed" };
  }
}

// 🔹 SAVE USER SETTINGS
export async function saveUserSettings(user_set_data1, user_set_data2, user_set_cre_by) {
  try {
    const fd = new FormData();
    fd.append("user_set_data1", user_set_data1);
    fd.append("user_set_data2", user_set_data2);
    fd.append("user_set_cre_by", user_set_cre_by);

    const response = await axios.post(`${apiBaseUrl}settingsapis/save_user_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("saveUserSettings error:", error);
    return { status: false, type: "danger", success: "User settings save failed" };
  }
}

// 🔹 GET ADMIN SETTINGS
export async function getAdminSettings(admin_set_cre_by) {
  try {
    const fd = new FormData();
    fd.append("admin_set_cre_by", admin_set_cre_by);

    const response = await axios.post(`${apiBaseUrl}settingsapis/get_admin_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getAdminSettings error:", error);
    return { status: false, type: "danger", success: "Failed to load admin settings" };
  }
}

// 🔹 GET USER SETTINGS
export async function getUserSettings(user_set_cre_by) {
  try {
    const fd = new FormData();
    fd.append("user_set_cre_by", user_set_cre_by);

    const response = await axios.post(`${apiBaseUrl}settingsapis/get_user_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getUserSettings error:", error);
    return { status: false, type: "danger", success: "Failed to load user settings" };
  }
}